import { Component } from '@theme/component';

/**
 * Starts the illustration's reveal, and the delayed entrance of its sibling
 * blocks, once the block enters the viewport. Both effects are pure CSS: this
 * element only flips `data-state`, and the CSS falls back to a fixed delay when
 * the module never runs, so the drawing always ends up visible.
 *
 * @extends {Component}
 */
class IllustrationReveal extends Component {
  /** @type {IntersectionObserver | undefined} */
  #observer;

  connectedCallback() {
    super.connectedCallback();

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        this.#observer?.disconnect();
        this.dataset.state = 'play';
      },
      { threshold: 0.3 }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }
}

if (!customElements.get('illustration-reveal')) {
  customElements.define('illustration-reveal', IllustrationReveal);
}
